/** Цифры российского номера без `+7`: ровно 10 */
const RUSSIAN_PHONE_PATTERN = /^\d{10}$/;

export const isRussianPhone = (digits: string): boolean => RUSSIAN_PHONE_PATTERN.test(digits);
